// @generated by protoc-gen-es v1.7.2
// @generated from file penumbra/core/component/ibc/v1/ibc.proto (package penumbra.core.component.ibc.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { Any, proto3 } from "@bufbuild/protobuf";
import { Amount } from "../../../num/v1/num_pb.js";
import { Denom } from "../../../asset/v1/asset_pb.js";
import { Address } from "../../../keys/v1/keys_pb.js";
import { Height } from "@buf/cosmos_ibc.bufbuild_es/ibc/core/client/v1/client_pb.js";

/**
 * @generated from message penumbra.core.component.ibc.v1.IbcRelay
 */
export const IbcRelay = proto3.makeMessageType(
  "penumbra.core.component.ibc.v1.IbcRelay",
  () => [
    { no: 1, name: "raw_action", kind: "message", T: Any },
  ],
);

/**
 * FungibleTokenPacketData defines a struct for the packet payload
 * See FungibleTokenPacketData spec:
 * https://github.com/cosmos/ibc/tree/master/spec/app/ics-020-fungible-token-transfer#data-structures
 *
 * @generated from message penumbra.core.component.ibc.v1.FungibleTokenPacketData
 */
export const FungibleTokenPacketData = proto3.makeMessageType(
  "penumbra.core.component.ibc.v1.FungibleTokenPacketData",
  () => [
    { no: 1, name: "denom", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "amount", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "sender", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "receiver", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "memo", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * A Penumbra transaction action requesting an ICS20 transfer.
 *
 * @generated from message penumbra.core.component.ibc.v1.Ics20Withdrawal
 */
export const Ics20Withdrawal = proto3.makeMessageType(
  "penumbra.core.component.ibc.v1.Ics20Withdrawal",
  () => [
    { no: 1, name: "amount", kind: "message", T: Amount },
    { no: 2, name: "denom", kind: "message", T: Denom },
    { no: 3, name: "destination_chain_address", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "return_address", kind: "message", T: Address },
    { no: 5, name: "timeout_height", kind: "message", T: Height },
    { no: 6, name: "timeout_time", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 7, name: "source_channel", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message penumbra.core.component.ibc.v1.ClientData
 */
export const ClientData = proto3.makeMessageType(
  "penumbra.core.component.ibc.v1.ClientData",
  () => [
    { no: 1, name: "client_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "client_state", kind: "message", T: Any },
    { no: 3, name: "processed_time", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "processed_height", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
  ],
);

/**
 * @generated from message penumbra.core.component.ibc.v1.ClientCounter
 */
export const ClientCounter = proto3.makeMessageType(
  "penumbra.core.component.ibc.v1.ClientCounter",
  () => [
    { no: 1, name: "counter", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
  ],
);

/**
 * @generated from message penumbra.core.component.ibc.v1.ConsensusState
 */
export const ConsensusState = proto3.makeMessageType(
  "penumbra.core.component.ibc.v1.ConsensusState",
  () => [
    { no: 1, name: "consensus_state", kind: "message", T: Any },
  ],
);

/**
 * @generated from message penumbra.core.component.ibc.v1.VerifiedHeights
 */
export const VerifiedHeights = proto3.makeMessageType(
  "penumbra.core.component.ibc.v1.VerifiedHeights",
  () => [
    { no: 1, name: "heights", kind: "message", T: Height, repeated: true },
  ],
);

/**
 * @generated from message penumbra.core.component.ibc.v1.ConnectionCounter
 */
export const ConnectionCounter = proto3.makeMessageType(
  "penumbra.core.component.ibc.v1.ConnectionCounter",
  () => [
    { no: 1, name: "counter", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
  ],
);

/**
 * @generated from message penumbra.core.component.ibc.v1.ClientConnections
 */
export const ClientConnections = proto3.makeMessageType(
  "penumbra.core.component.ibc.v1.ClientConnections",
  () => [
    { no: 1, name: "connections", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ],
);

/**
 * IBC configuration data.
 *
 * @generated from message penumbra.core.component.ibc.v1.IbcParameters
 */
export const IbcParameters = proto3.makeMessageType(
  "penumbra.core.component.ibc.v1.IbcParameters",
  () => [
    { no: 1, name: "ibc_enabled", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "inbound_ics20_transfers_enabled", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 3, name: "outbound_ics20_transfers_enabled", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * IBC genesis state.
 *
 * @generated from message penumbra.core.component.ibc.v1.GenesisContent
 */
export const GenesisContent = proto3.makeMessageType(
  "penumbra.core.component.ibc.v1.GenesisContent",
  () => [
    { no: 1, name: "ibc_params", kind: "message", T: IbcParameters },
  ],
);

